function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReligionsAndBeliefs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.711,1.187C22.915,1.06 23.131,0.977 23.347,0.926C23.646,0.862 23.958,0.869 24.245,0.932C24.735,1.047 25.186,1.346 25.479,1.798L33.109,13.239C33.669,14.073 33.961,15.059 33.961,16.065L33.961,20.742C33.961,21.181 34.241,21.569 34.655,21.709L39.695,23.389C40.528,23.662 41.088,24.439 41.088,25.317L41.088,31.426C41.088,32.056 40.796,32.654 40.293,33.042C39.79,33.43 39.141,33.557 38.53,33.392L27.789,30.529C24.225,29.58 21.744,26.348 21.744,22.657L21.744,15.136C21.744,14.009 22.654,13.099 23.78,13.099C24.906,13.099 25.816,14.009 25.816,15.136L25.816,20.226C25.816,20.786 26.274,21.244 26.834,21.244C27.394,21.244 27.853,20.786 27.853,20.226L27.853,14.824C27.853,14.378 27.738,13.946 27.515,13.564L22.017,3.942C21.909,3.751 21.833,3.554 21.788,3.351C21.725,3.051 21.725,2.74 21.795,2.453C21.916,1.944 22.227,1.486 22.705,1.187L22.711,1.187ZM18.74,1.187C19.218,1.48 19.529,1.944 19.65,2.453C19.72,2.746 19.727,3.051 19.657,3.351C19.612,3.554 19.536,3.751 19.427,3.942L13.936,13.564C13.713,13.946 13.599,14.385 13.599,14.824L13.599,20.226C13.599,20.786 14.057,21.244 14.617,21.244C15.177,21.244 15.635,20.786 15.635,20.226L15.635,15.136C15.635,14.009 16.545,13.099 17.671,13.099C18.798,13.099 19.707,14.009 19.707,15.136L19.707,22.663C19.707,26.354 17.226,29.58 13.662,30.535L2.927,33.398C2.316,33.564 1.661,33.43 1.165,33.048C0.668,32.667 0.363,32.062 0.363,31.426L0.363,25.317C0.363,24.439 0.923,23.662 1.756,23.382L6.796,21.703C7.21,21.563 7.49,21.174 7.49,20.735L7.49,16.058C7.49,15.053 7.789,14.073 8.342,13.233L15.966,1.804C16.259,1.352 16.71,1.053 17.2,0.939C17.493,0.869 17.798,0.862 18.098,0.932C18.32,0.983 18.537,1.066 18.734,1.193L18.74,1.187Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReligionsAndBeliefs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/religions-and-beliefs.5d866d7d99493fa2827f132de2713c3c.svg";